import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { fetchInvoices} from '../../../../../Redux/Actions/Admin/ManageInvoiceActions'; 

class InvoiceForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			invoiceInEdit: this.props.dataItem || null,
			value: []
		};
	}
	/*
	componentDidMount() {
		this.props.fetchInvoices();
	}*/
	

	handleSubmit = (event) => {
		event.preventDefault();
        if (this.state.invoiceInEdit.invoiceId) {
            this.props.updateInvoice(this.state.invoiceInEdit);
            this.props.cancel(); 
        }
	
	};
	isCustom(item) {
		return item.id === undefined;
	}
	addKey(item) {
		item.id = new Date().getTime();
	}
	onDialogInputChange = (event) => {
        let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.invoiceInEdit;
		edited[name] = value;
		edited.isActive = true;
		this.setState({
			invoiceInEdit: edited
		});
    };

	render() {
		return (
			<Dialog onClose={this.props.cancel}>
				{<h2>Edit Invoice</h2>}
				<form className="user-form" onSubmit={this.handleSubmit}>
					<div>
						<label>
                           Invoice ID<br />
							<Input
								required={true}
								type="text"
								name="number"
								value={this.state.invoiceInEdit.number || ''}
								onChange={this.onDialogInputChange}
							/>
						</label>
					</div>
					<div>
						<label>
                           Name<br />
							<Input
								required={true}
								type="text"
								name="name"
								value={this.state.invoiceInEdit.name || ''}
								onChange={this.onDialogInputChange}
							/>
						</label>
					</div>
					<div>
						<label>
                        Description<br />
							<Input
								type="text"
								name="description"
								value={this.state.invoiceInEdit.description || ''}
								onChange={this.onDialogInputChange}
							/>
						</label>
					</div>
					<div>
						<label>
                    	Amount Due<br />
							<Input
								type="text"
								name="amountDue"
								value={this.state.invoiceInEdit.amountDue || ''}
								onChange={this.onDialogInputChange}
							/>
						</label>
					</div>
					<div>
						<label>
                    	Date<br />
							<Input
								type="text"
								name="dateOfAmount"
								value={this.state.invoiceInEdit.dateOfAmount || ''}
								onChange={this.onDialogInputChange}
							/>
						</label>
					</div>
					<div>
						<label>
                        PDF Link<br />
							<Input
								type="text"
								name="invoicePdf"
								value={this.state.invoiceInEdit.invoicePdf || ''}
								onChange={this.onDialogInputChange}
							/>
						</label>
					</div>
					<div>
						<label>
                        Active Invoice<br />
							<Input
								type="text"
								name="isActive"
								value={this.state.invoiceInEdit.isActive || ''}
								onChange={this.onDialogInputChange}
							/>
						</label>
					</div>
					

					<DialogActionsBar>
						<button className="admin-k-button" onClick={this.props.cancel}>
							CANCEL
						</button>
						{!this.state.invoiceInEdit.invoiceId ? (
							<button type="submit" className="admin-k-button">
								SAVE
							</button>
						) : (
							<button type="submit" className="admin-k-button">
								UPDATE
							</button>
						)}
					</DialogActionsBar>
				</form>
			</Dialog>
		);
	}
}

export default InvoiceForm;
